import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { putGroupEdit } from "./candidateListFunctions";

const statusVisaCancelled = ["SELECTED", "VISA CANCELLED"];

const statusVisaCancelledClientRequirementFulfilled = [
  "SELECTED",
  "VISA CANCELLED REQUIREMENT FULFILLED",
];

export default function GroupEditPopupCancelled({
  popupState,
  setPopupState,
  setCandidateListData,
  checkedList,
  hideInputs = [],
  ResetFilter,
  status,
}) {
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const [visaProfessionId, setVisaProfessionId] = useState();

  const [finalObj, setFinalObj] = useState({});

  const [submitLoading, setSubmitLoading] = useState(false);

  const handleGroupEdit = async (e) => {
    e.preventDefault();
    const body = [];
    for (let selectedId of checkedList) {
      body.push({
        ...finalObj,
        visa_profession_id: visaProfessionId,
        id: selectedId,
      });
    }
    const response = await putGroupEdit(
      projectId,
      body,
      setCandidateListData,
      setSubmitLoading,
      dispatch
    );
    if (response.completed) {
      ResetFilter();
      setPopupState({ open: false });
    }
  };

  console.log(finalObj, "finalObj");

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        popupState.open ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-xl w-full h-auto min-h-[15rem] max-h-[35rem] rounded-md bg-white/95 flex  flex-col p-4 relative overflow-y-scroll">
        <div className="flex justify-between items-center w-full">
          <div>
            <h1 className="text-xl font-semibold">Group Edit</h1>
            <h2 className="text-sm">Group Edit Candidate List</h2>
          </div>
          <h1
            className="text-md font-semibold cursor-pointer"
            onClick={() => {
              setPopupState((p) => ({ open: false }));
            }}
          >
            <IoMdClose />
          </h1>
        </div>
        <form className="px-5 py-2 mt-5" onSubmit={handleGroupEdit}>
          <ArraySelectInput
            title="Status"
            array={
              status == "VISA CANCELLED"
                ? statusVisaCancelled
                : statusVisaCancelledClientRequirementFulfilled
            }
            objKey="status"
            setFinalObj={setFinalObj}
            hideInputs={hideInputs}
            required
          />

          <div className="p-2  w-full flex gap-3">
            <button
              type="button"
              className="ring-1 ring-slate-300  uppercase w-full text-xs rounded-md py-2 flex justify-center items-center gap-2"
              disabled={submitLoading}
              onClick={() => setPopupState({ open: false })}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={
                "bg-red uppercase w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              }
              disabled={submitLoading}
            >
              Submit
              {submitLoading && <CgSpinner className="animate-spin" />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const ArraySelectInput = ({
  title,
  array,
  arrayValue,
  objKey,
  setFinalObj,
  hideInputs = [],
  required = false,
}) => {
  return (
    <div
      className={`form-control w-full gap-[0.15rem] mb-4 ${
        hideInputs.includes(objKey) ? "hidden" : ""
      }`}
    >
      <label className="label py-0">
        <span className="label-text">{title}</span>
      </label>
      <select
        className="select select-sm select-bordered"
        onChange={(e) =>
          setFinalObj((prevState) => ({
            ...prevState,
            [objKey]: e.target.value,
          }))
        }
        required={required}
      >
        <option value="" hidden>
          Select an Option
        </option>
        {array?.map((data) => (
          <option value={data?.id || data} key={data?.id}>
            {data?.name || data}
          </option>
        ))}
      </select>
    </div>
  );
};

const TextInput = ({
  title,
  type,
  objKey,
  setFinalObj,
  hideInputs,
  required = false,
}) => {
  return (
    <div
      className={`form-control w-full gap-[0.15rem] mb-4 ${
        hideInputs.includes(objKey) ? "hidden" : ""
      }`}
    >
      <label className="label py-0">
        <span className="label-text">{title}</span>
      </label>
      <input
        required={required}
        type={type || "text"}
        placeholder="Type here"
        className="input input-sm input-bordered w-full"
        onChange={(e) => {
          if (String(e.target.value).trim() != "") {
            setFinalObj((prevState) => ({
              ...prevState,
              [objKey]:
                type == "date"
                  ? String(e.target.value).split("-").reverse().join("-")
                  : e.target.value,
            }));
          } else {
            setFinalObj((prevState) => {
              const copyFinalObj = { ...prevState };
              delete copyFinalObj[objKey];
              return copyFinalObj;
            });
          }
        }}
      />
    </div>
  );
};
